import {
  Box,
  Button,
  Stack,
  Typography,
  ButtonBase,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useState } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import React from "react";
import NaranjoLogo from "../../Images/JCH-logo-cropped.png";
import { ImFacebook } from "react-icons/im";
import {
  AiOutlineYoutube,
  AiOutlineTwitter,
  AiOutlineInstagram,
} from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import "./Style.css";
import { getLocalizedText } from "../../utils/language";

const Footer = () => {
  const allList = useSelector((state) => state.allList.list);
  const navigate = useNavigate();
  const year = new Date().getFullYear();
  const postData = {
    language: localStorage.getItem("language") || "es",
    search: "",
    skills: "",
    city: "",
    category: "",
    type: "",
  };
  const [showprivacy, setShowprivacy] = useState(false);
  const [showterms, setShowterms] = useState(false);
  const handleOpenterms = () => {
    setShowterms(true);
  };
  const handleCloseterms = () => {
    setShowterms(false);
  };

  const handleOpenDialog = () => {
    setShowprivacy(true);
  };

  const handleCloseDialog = () => {
    setShowprivacy(false);
  };
  const Labels = useSelector((state) => state.allLabels.labels);
  return (
    <Box component="footer" className="narajoFooter">
      <Box className="narajoFooterInner">
        <Box className="narajoFooterBrand">
          <Box className="narajoFooterLogo">
            <img src={NaranjoLogo} alt="Narajo logo" />
          </Box>
          <Typography className="narajoFooterTitle">
            {Labels?.JobPortal || getLocalizedText("Portal de empleo", "Job Portal")}
          </Typography>
          <Typography className="narajoFooterText">
            {getLocalizedText("Encuentra empleos de confianza, conecta con empresas y haz avanzar tu carrera con Narajo.", "Find reliable roles, connect with employers, and keep your career moving with Narajo.")}
          </Typography>
        </Box>

        <Box className="narajoFooterColumn">
          <Typography className="narajoFooterHeading">{getLocalizedText("Explorar", "Explore")}</Typography>
          <Stack className="narajoFooterLinks">
            <Button
              variant="text"
              onClick={() =>
                navigate("/jobSearchPrelogin", { state: postData })
              }
            >
              {Labels?.Jobs || getLocalizedText("Empleos", "Jobs")}
            </Button>
            <Button
              variant="text"
              onClick={() => navigate("/about")}
            >
              {Labels?.AboutUs || getLocalizedText("Quiénes somos", "About Us")}
            </Button>
            <Button
              variant="text"
              onClick={() => navigate("/contact")}
            >
              {Labels?.Contactus || getLocalizedText("Contacto", "Contact Us")}
            </Button>
          </Stack>
        </Box>

        <Box className="narajoFooterColumn">
          <Typography className="narajoFooterHeading">{getLocalizedText("Información legal", "Legal")}</Typography>
          <Stack className="narajoFooterLinks">
            <Button
              variant="text"
              onClick={() => {
                handleOpenterms();
              }}
            >
              {Labels?.TandC || getLocalizedText("Términos y condiciones", "Terms and Conditions")}
            </Button>
            <Button
              variant="text"
              onClick={() => {
                handleOpenDialog();
              }}
            >
              {Labels?.PrivacyPolicy || getLocalizedText("Política de privacidad", "Privacy Policy")}
            </Button>
          </Stack>
        </Box>

        <Box className="narajoFooterColumn">
          <Typography className="narajoFooterHeading">{getLocalizedText("Síguenos", "Follow Us")}</Typography>
          <Stack direction="row" className="narajoFooterSocials">
            <ButtonBase className="narajoSocialButton" aria-label="Facebook">
              <ImFacebook />
            </ButtonBase>
            <ButtonBase className="narajoSocialButton" aria-label="Youtube">
              <AiOutlineYoutube />
            </ButtonBase>
            <ButtonBase className="narajoSocialButton" aria-label="Twitter">
              <AiOutlineTwitter />
            </ButtonBase>
            <ButtonBase className="narajoSocialButton" aria-label="Instagram">
              <AiOutlineInstagram />
            </ButtonBase>
          </Stack>
        </Box>
      </Box>

      <Box className="narajoFooterBottom">
        <Typography>
          {Labels?.AllRightsReserved} &copy; {year}
        </Typography>
        <Typography>{Labels?.DevelopedbyM2india}</Typography>
      </Box>

      <Dialog open={showterms} onClose={handleCloseterms}>
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ p: 0.5, mt: 0.5 }}
        >
          <DialogTitle
            sx={{
              color: "#005F8E",
            }}
          >
            {Labels?.TandC}
          </DialogTitle>
          <HighlightOffIcon
            sx={{
              color: "#005F8E",
              cursor: "pointer",
              m: 2,
            }}
            onClick={handleCloseterms}
          />
        </Stack>
        <DialogContent sx={{ pt: 0, mb: 1 }}>
          {allList?.privacyPolicy?.terms && (
            <Typography>{allList?.privacyPolicy?.terms}</Typography>
          )}
        </DialogContent>
      </Dialog>

      <Dialog open={showprivacy} onClose={handleCloseDialog}>
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ p: 0.5, mt: 0.5 }}
        >
          <DialogTitle
            sx={{
              color: "#005F8E",
            }}
          >
            Privacy Policy
          </DialogTitle>
          <HighlightOffIcon
            sx={{
              color: "#005F8E",
              cursor: "pointer",
              m: 2,
            }}
            onClick={handleCloseDialog}
          />
        </Stack>

        <DialogContent sx={{ pt: 0, mb: 1 }}>
          {allList?.privacyPolicy?.privacy && (
            <Typography>{allList?.privacyPolicy?.privacy}</Typography>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Footer;
